import { z } from 'zod';
import { ADMIN_ROLES } from '../constants/index.js';

export const AdminInviteSchema = z.object({
  email: z.string().trim().toLowerCase().email(),
  role: z.enum(ADMIN_ROLES),
  display_name: z.string().trim().min(1).max(120).optional(),
});
export type AdminInviteInput = z.infer<typeof AdminInviteSchema>;

export const AdminRoleChangeSchema = z.object({
  user_id: z.string().uuid(),
  role: z.enum(ADMIN_ROLES),
  display_name: z.string().trim().min(1).max(120).nullable().optional(),
});
export type AdminRoleChangeInput = z.infer<typeof AdminRoleChangeSchema>;

export const AdminUserSetStatusSchema = z.object({
  user_id: z.string().uuid(),
  status: z.enum(['active', 'suspended']),
});
export type AdminUserSetStatusInput = z.infer<typeof AdminUserSetStatusSchema>;

/** Pagination + filters reused by all admin list endpoints. */
export const AdminListQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  per_page: z.coerce.number().int().min(1).max(100).default(25),
  search: z.string().trim().max(120).optional(),
});
export type AdminListQuery = z.infer<typeof AdminListQuerySchema>;
